// Authentication page component
import { useState } from "react";
import { Heading, Button, Input } from "../atoms";
import { useAuth } from "../../contexts/AuthContext";

export const AuthPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const { login } = useAuth();

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);

    try {
      const result = await login(email, password);
      if (!result.success) {
        setError(result.error || "Invalid email or password");
      }
    } catch (err) {
      setError("An error occurred. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-amber-600 to-orange-700 flex items-center justify-center px-4">
      <div className="max-w-md w-full bg-white/95 rounded-2xl shadow-2xl p-10">
        <div className="text-center mb-6">
          <Heading level={1} className="flex items-center justify-center">
            Login
          </Heading>
        </div>

        <form onSubmit={handleSubmit} className="space-y-6">
          <div>
            <label className="block text-sm font-semibold mb-2 text-ink">
              Email
            </label>
            <Input
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="Enter your email"
              className="text-lg border-2 border-amber-300"
              required
              autoFocus
            />
          </div>
          <div>
            <label className="block text-sm font-semibold mb-2 text-ink">
              Password
            </label>
            <Input
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Enter your password"
              className="text-lg border-2 border-amber-300"
              required
            />
          </div>
          <Button
            variant="primary"
            type="submit"
            className="w-full py-4 text-lg"
            disabled={loading}
          >
            {loading ? "Logging in..." : "Login"}
          </Button>
          {error && (
            <p className="text-red-600 font-medium text-center">{error}</p>
          )}
        </form>
      </div>
    </div>
  );
};
